import React from 'react';
import { Descriptions, Typography } from 'antd';
import Tag from '@/components/Tag';
import { OpenCardCompleteResult } from '@/types/member';
import drawerStyles from '../index.less';
import styles from './StepComplete.less';

interface IProps {
  result: OpenCardCompleteResult;
}

export default function StepComplete({ result }: IProps) {
  const isOnline = result.payMethod === 'online';
  const title = isOnline ? '创建订单成功' : '开卡成功';

  return (
    <div>
      <Typography.Title level={4} className={drawerStyles.screenTitle}>
        {title}
      </Typography.Title>

      <Descriptions
        bordered
        column={1}
        size="middle"
        className={styles.successPanel}
        styles={{
          label: {
            width: 112,
            minWidth: 112,
            whiteSpace: 'nowrap',
          },
        }}
      >
        <Descriptions.Item label="开卡用户">
          {result.userName}（{result.phoneNumber}）
        </Descriptions.Item>

        <Descriptions.Item label="会员卡信息">
          <div className={styles.finishCardMain}>
            <strong>{result.memberCardName}</strong>
            <Tag color="blue">{result.memberCardTypeName}</Tag>
          </div>
          <div className={styles.finishCardMeta}>
            {result.totalCardNum !== undefined && (
              <span>
                总次数：<strong>{result.totalCardNum} 次</strong>
              </span>
            )}
            <span>
              有效期：<strong>{result.validDays} 天</strong>
            </span>
            <span>
              实付金额：<strong>{result.actualAmount} 元</strong>
            </span>
          </div>
        </Descriptions.Item>

        <Descriptions.Item label="激活方式">{result.activateTypeLabel}</Descriptions.Item>
        <Descriptions.Item label="开卡门店">{result.issuingStoreName}</Descriptions.Item>
        <Descriptions.Item label="开卡负责人">{result.issuingAdminName}</Descriptions.Item>
      </Descriptions>
    </div>
  );
}
